<template>
  <div class="fyb">
    <!-- <paging-fy  @currentPageChange="currentPageChange" 
      :currentPage="currentPage" :total="courseTotal"></paging-fy> -->
    <div class="fyb1">
      <el-pagination
        :current-page="currentPage"
        :total="total"
        @current-change="currentPageChange"
      >
      </el-pagination>
    </div>
    <div class="fyb2">
      <el-pagination
        layout="prev, pager, next"
        :total="total"
        @current-change="currentPageChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pagingfy",
  props: ["currentPage", "total"],
  methods: {
    currentPageChange(e) {
      this.$emit("currentPageChange", e);
    },
  },
};
</script>

<style lang="less">
.fyb {
  display: flex;
  height: 50px;
  width: 100%;
  align-items: center;
  @media screen and(max-width: 768px) {
    justify-content: center;
  }
  .fyb1 {
    display: block;
    @media screen and(max-width: 768px) {
      display: none;
    }
  }
  .fyb2 {
    display: none;
    @media screen and(max-width: 768px) {
      display: block;
    }
  }
}
</style>
